import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import "./formProgress.scss";
import { useRecoilState, useRecoilValue } from "recoil";
import { formProgress } from "../../../store/atoms";

const steps = [
  "Unit Details",
  "Audit Details",
  "Protocol Details",
  "Scoring Details",
  "MARS Verification",
];

export default function FormProgress() {
  const [progressValue] = useRecoilState(formProgress);
  return (
    <Box id="formProgress">
      <Stepper activeStep={progressValue} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
